module.exports = __webpack_public_path__ + "media/images/stars/0@2x-d8fb29e9e9f517e8981c11d1e8430c47.png";